import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reset",
  "use": "icon-reset-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-reset\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M12,18a6,6,0,1,1,6-6A6,6,0,0,1,12,18ZM15,15.1a4.27,4.27,0,1,0-1.13.78l-.6-1.08A3.06,3.06,0,1,1,15.06,12H13.23L15,15.1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol